<div class="modal-header">
    <h4 class="modal-title"> {{ 'CARDOPERATIONS_ONLINE_CHARGE_CVV_INFORMATION_TITLE' | translate }} </h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <p>{{title}}</p>
</div>
<div class="modal-footer">
    <button 
      type="button" 
      class="btn btn-outline-dark" 
      (click)="activeModal.close('Close click')"
  >{{ 'CARDOPERATIONS_ONLINE_CHARGE_CVV_INFORMATION_CLOSE_BTN' | translate }}</button>
</div>